import { addLoading, removeLoading } from './loading';
import BrandsRequests from '../../server/brands';

export const getBrands = res => ({
  type: 'GET_BRANDS',
  brands: res,
});

export const getBrandsAction = () => async (dispatch) => {
  const brands = await BrandsRequests.getBrands();
  dispatch(getBrands(brands));
};

export const getAllBrands = () => async (dispatch) => {
  dispatch(addLoading());
  try {
    return await BrandsRequests.getAllBrands();
  } finally {
    dispatch(removeLoading());
  }
};
